"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var useCss_1 = require("./useCss");

var emptyStylesFactory = function emptyStylesFactory() {
  return {};
};

exports.useStyles = function (factory) {
  if (factory === void 0) {
    factory = emptyStylesFactory;
  }

  var args = [];

  for (var _i = 1; _i < arguments.length; _i++) {
    args[_i - 1] = arguments[_i];
  }

  var _a = useCss_1.useCss(),
      css = _a.css,
      theme = _a.theme;

  var map = factory.apply(void 0, [theme].concat(args));
  var classes = Object.keys(map).reduce(function (all, className) {
    var _a;

    return __assign({}, all, (_a = {}, _a[className] = css(map[className]), _a));
  }, {});
  return {
    classes: classes,
    css: css,
    theme: theme
  };
};